import { Component, HostListener, Input, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { SnackbarService } from '../../services/design/snackbar.service';
import { MenuGroup, Menus } from './menuItem';

@Component({
  standalone: true,
  selector: 'app-sidebar',
  imports: [RouterModule],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly snackbar = inject(SnackbarService);

  @Input() collapsed = false;

  expandedMenu: string | null = null;
  appConfig = environment.appConfig;
  submenuTopPosition = 0;
  
  public loginUser = this.auth.user;
  sidebarWidth = 80;
  
  get menuItems(): MenuGroup[] {
    return Menus.filter(menu => this.hasAccess(menu.roles)).map(menu => ({
      ...menu,
      children: menu.children?.filter(child => !child.roles || this.hasAccess(child.roles)),
    })).filter(menu => !menu.children || menu.children.length > 0);
  }

  hasAccess(roles: string[]): boolean {
    return this.auth.hasRole(roles);
  }

  settingsPath(): string {
    return this.auth.hasStoreOperations() ? '/settings' : '/settings/account-details';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (!target.closest('aside') && this.expandedMenu !== null) {
      this.expandedMenu = null;
    }
  }

  toggleMenu(label: string, event?: MouseEvent) {
    if (this.expandedMenu === label) {
      this.expandedMenu = null;
    } else {
      this.expandedMenu = label;

      if (this.collapsed && event) {
        const button = event.currentTarget as HTMLElement;
        const rect = button.getBoundingClientRect();
        this.submenuTopPosition = rect.top + rect.height / 2;

        const submenuHeight = 200;
        const viewportHeight = window.innerHeight;
        const minTop = submenuHeight / 2 + 10;
        const maxTop = viewportHeight - submenuHeight / 2 - 10;

        if (this.submenuTopPosition < minTop) this.submenuTopPosition = minTop;
        if (this.submenuTopPosition > maxTop) this.submenuTopPosition = maxTop;
      }
    }
  }

  navigate(route?: string): void {
    if (route) {
      this.router.navigate([route]);
    }
  }

  async logout() {
    await this.auth.logout();
    this.snackbar.success('Logged out successfully');
    this.router.navigate(['/login']);
  }
}
